<template>
  <div class="box">
    <div class="in-box">
      <div class="emergency-box ml-4 pt-3">
        <label class="col-form-label">วันที่สั่งตรวจ :</label>
        <div class="col-2">
          <datetime
            v-model="dateNow"
            :input-class="{
              'form-control': true,
            }"
            type="date"
            class="theme-orange datepicker-trigger input-group"
            placeholder="Select Date"
            format="dd-MM-yyyy"
            value-zone="local"
          />
        </div>
      </div>
      <div class="left emergency-box ml-4">
        <label class="check-box emer-check-box">
          <input v-model="emergency" type="checkbox" value="1" />ด่วนพิเศษ
          <span class="checkmark" />
        </label>
        <!-- <label class="col-form-label ml-5">ขอผลก่อนเวลา :</label>
        <div
          class="emer-datetime col-2"
          @mouseover="activeCloseDate = true"
          @mouseleave="activeCloseDate = false"
        >
          <datetime
            v-model="time"
            :input-class="{
              'form-control': true,
              'border-right-0': true,
              invalidTime: isInvalidTime,
            }"
            :disabled="emergency == ''"
            type="time"
            class="theme-orange datepicker-trigger input-group"
            placeholder="Select Time"
            value-zone="local"
          >
            <div slot="after" class="input-group-prepend bg-white">
              <span
                id="basic-addon1"
                class="input-group-text border-left-0 rounded-right bg-white"
                :class="{
                  invalidTime: isInvalidTime,
                  disabled: emergency == '',
                }"
              >
                <fa-icon
                  v-show="activeCloseDate && emergency != ''"
                  :icon="['fas', 'times']"
                  class="icon"
                  @click="clearDate"
                />
              </span>
            </div>
          </datetime>
        </div> -->
      </div>
      <div class="left emergency-box">
        <label class="check-box emer-check-box">
          <b-form-radio-group
            id="is-out-lab-radio-check"
            v-model="isOutLab"
            :options="isOutLabOptions"
            name="radio-options-check"
          ></b-form-radio-group>
        </label>
      </div>
      <div class="text left">Type of Specimens :</div>
      <div class="check-box-top">
        <template v-for="specimenType in specimenTypes">
          <div :key="specimenType.index" class="mini-top-box left">
            <label class="check-box">
              <input
                v-model="select"
                type="checkbox"
                :value="specimenType.id"
              />
              <template v-if="specimenType.name === 'Other'">
                <input
                  v-model="otherSpecimen"
                  type="text"
                  class="form-control"
                  placeholder="Other"
                />
              </template>
              <template v-else>{{ specimenType.name }}</template>

              <span class="checkmark" />
            </label>
          </div>
        </template>
      </div>
      <b-row v-if="!isOutLab" class="justify-content-center">
        <b-col class="col-lg-4 pr-0">
          <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Hematology')"
          />
          <test-type-checklist-box
            set-test
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getSetTest('Routine Set Test')"
          />
          <test-type-checklist-box
            set-test
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getSetTest('Kidney Profile Set Test')"
          />
          <test-type-checklist-box
            set-test
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getSetTest('Liver Profile Set Test')"
          />
          <test-type-checklist-box
            set-test
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getSetTest('Pancreatic Profile Set Test')"
          />
          <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Fluid Analysis')"
          />
          <!-- <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Miscellaneous')"
          /> -->
          <!-- <test-type-checklist-box
            horizontal="4"
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Hormone')"
          /> -->
        </b-col>
        <b-col class="col-lg-4 p-0">
          <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            horizontal="6"
            :test-type="getTestType('Blood Chemistry')"
          />
          <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Urine Examination')"
          />
          <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Drugs')"
          />
          <!-- <b-row>
            <b-col class="col-lg-6 pr-0">
              <test-type-checklist-box
                horizontal
                test-kit
                :test-selected.sync="items"
                :is-out-lab="isOutLab"
                :test-type="getTestType('Test Kit')"
              />
              <test-type-checklist-box
                horizontal="6"
                :test-selected.sync="items"
                :is-out-lab="isOutLab"
                :test-type="getTestType('Urine Examination')"
              />
              <test-type-checklist-box
                :test-selected.sync="items"
                :is-out-lab="isOutLab"
                :test-type="getTestType('Immunology')"
              />
              <test-type-checklist-box
                horizontal="6"
                :test-selected.sync="items"
                :is-out-lab="isOutLab"
                :test-type="getTestType('Drugs')"
              />
            </b-col>
            <b-col class="col-lg-6 pl-0">
              <test-type-checklist-box
                :test-selected.sync="items"
                :is-out-lab="isOutLab"
                :test-type="getTestType('V Check')"
              />
              <test-type-checklist-box
                :test-selected.sync="items"
                :is-out-lab="isOutLab"
                :test-type="getTestType('I DEX')"
              />
              <test-type-checklist-box
                :test-selected.sync="items"
                :is-out-lab="isOutLab"
                :test-type="getTestType('Coagulation disorder')"
              />
              <test-type-checklist-box
                :test-selected.sync="items"
                :is-out-lab="isOutLab"
                :test-type="getTestType('Compatibility test')"
              />
            </b-col>
          </b-row> -->
        </b-col>
        <b-col class="col-lg-4 pl-0">
          <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Miscellaneous')"
          />
          <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Test Kit')"
          />
          <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Coagulation disorder')"
          />
          <!-- <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Microbiology')"
          />
          <test-type-checklist-box
            horizontal="6"
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('PCR Technique for Infectious Disease')"
          />
          <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('PCR Technique for Blood parasite')"
          />
          <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Pathology and Histopathology')"
          /> -->
          <!-- <test-type-checklist-box
            :test-selected.sync="items"
            :test-type="getTestType('Fluid Analysis')"
          />-->
          <!-- <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Special Test')"
          /> -->
        </b-col>
      </b-row>
      <b-row v-if="isOutLab" class="justify-content-center">
        <b-col class="col-lg-4 pr-0">
          <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Microbiology')"
          />
          <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Hormone')"
          />
          <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Immunology')"
          />
          <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Cytology')"
          />
          <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Blood Chemistry')"
          />

          <!-- <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Hematology')"
          />
          <test-type-checklist-box
            set-test
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getSetTest('Routine Set Test')"
          />
          <test-type-checklist-box
            set-test
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getSetTest('Kidney Profile Set Test')"
          />
          <test-type-checklist-box
            set-test
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getSetTest('Liver Profile Set Test')"
          />
          <test-type-checklist-box
            set-test
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getSetTest('Pancreatic Profile Set Test')"
          />
          <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Miscellaneous')"
          />
          <test-type-checklist-box
            horizontal="4"
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Hormone')"
          /> -->
        </b-col>
        <b-col class="col-lg-4 p-0">
          <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('PCR for Blood parasite')"
          />
          <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Special Test')"
          />
          <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Drugs')"
          />
          <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Coagulation disorder')"
          />
          <!-- <test-type-checklist-box
            horizontal
            blood-chemistry
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Blood Chemistry')"
          /> -->
          <!-- <b-row>
            <b-col class="col-lg-6 pr-0">
              <test-type-checklist-box
                horizontal
                test-kit
                :test-selected.sync="items"
                :is-out-lab="isOutLab"
                :test-type="getTestType('Test Kit')"
              />
              <test-type-checklist-box
                horizontal="6"
                :test-selected.sync="items"
                :is-out-lab="isOutLab"
                :test-type="getTestType('Urine Examination')"
              />
              <test-type-checklist-box
                :test-selected.sync="items"
                :is-out-lab="isOutLab"
                :test-type="getTestType('Immunology')"
              />
              <test-type-checklist-box
                horizontal="6"
                :test-selected.sync="items"
                :is-out-lab="isOutLab"
                :test-type="getTestType('Drugs')"
              />
            </b-col>
            <b-col class="col-lg-6 pl-0">
              <test-type-checklist-box
                :test-selected.sync="items"
                :is-out-lab="isOutLab"
                :test-type="getTestType('V Check')"
              />
              <test-type-checklist-box
                :test-selected.sync="items"
                :is-out-lab="isOutLab"
                :test-type="getTestType('I DEX')"
              />
              <test-type-checklist-box
                :test-selected.sync="items"
                :is-out-lab="isOutLab"
                :test-type="getTestType('Coagulation disorder')"
              />
              <test-type-checklist-box
                :test-selected.sync="items"
                :is-out-lab="isOutLab"
                :test-type="getTestType('Compatibility test')"
              />
            </b-col>
          </b-row> -->
        </b-col>
        <b-col class="col-lg-4 pl-0">
          <!-- <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Microbiology')"
          /> -->
          <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('PCR for Infectious Disease')"
          />
          <!-- <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('PCR Technique for Blood parasite')"
          /> -->
          <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Pathology')"
          />
          <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Urine Examination')"
          />
          <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('PCR')"
          />
          <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Drugs')"
          />
          <!-- <test-type-checklist-box
            :test-selected.sync="items"
            :test-type="getTestType('Fluid Analysis')"
          />-->
          <!-- <test-type-checklist-box
            :test-selected.sync="items"
            :is-out-lab="isOutLab"
            :test-type="getTestType('Special Test')"
          /> -->
        </b-col>
      </b-row>
      <b-row class="justify-content-end p-2">
        <b-col class="col-auto">
          <b-button class="btn btn-block" @click="reset(true)">รีเซ็ต</b-button>
        </b-col>
        <b-col class="col-auto">
          <b-button
            variant="success"
            class="btn btn-block"
            :disabled="isSending"
            @click="submit"
            >สั่งตรวจ</b-button
          >
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TestTypeChecklistBox from "./TestTypeChecklistBox.vue";
import moment from "moment-timezone";

export default {
  name: "TestCheckListForm",
  components: {
    TestTypeChecklistBox,
  },
  props: {
    saveAnimalFunction: {
      type: Function,
    },
  },
  data() {
    return {
      dateNow: null,
      emergency: null,
      activeCloseDate: false,
      time: "",
      select: [],
      items: [],
      testSelected: [],
      objHospitals: [],
      lstHospitals: [],
      objGenders: [],
      lstGenders: [],
      confirm: false,
      otherSpecimen: "",
      isSending: false,
      isOutLab: false,
      isOutLabOptions: [
        { text: "In Lab", value: false },
        { text: "Out Lab", value: true },
      ],
    };
  },
  computed: {
    ...mapGetters({
      data: "Animal/getData",
      specimenTypes: "Test/getSpecimenType",
      testTypes: "Test/getTestType",
      setTests: "Test/getSetTest",
      selectedSpecimenTypes: "Test/getSelectedSpecimenTypes",
      genders: "Gender/getAll",
      hospitals: "Hospital/getAll",
    }),
    isInvalidName() {
      return this.data.name == "" && this.confirm;
    },
    isInvalidTime() {
      return this.time == "" && this.confirm && this.emergency == "1";
    },
  },
  async created() {
    var localTime = moment().format("YYYY-MM-DD"); // store localTime
    var proposedDate = localTime + "T00:00:00.000Z";
    this.dateNow = proposedDate;
    await this.setCustomersData();
  },
  async mounted() {
    this.$nextTick((val) => {
      this.setGenders();
      this.setHospitals();
    });
  },
  methods: {
    ...mapActions({
      updateData: "Animal/updateData",
      saveOrder: "Order/saveOrder",
      checkPermission: "Order/checkPermission",
      setCustomersData: "Hospital/getAll",
      selected: "Test/setSelectedSpecimenType",
    }),
    async permission(type, mod) {
      let permission = await this.checkPermission({
        type: type,
        mod: mod,
      });

      if (!permission) {
        this.$notify({
          group: "alert",
          title: "มีข้อผิดพลาดบางอย่าง",
          text: permission,
          position: "bottom right",
          type: "error",
        });
        return false;
      }
      return true;
    },
    clearDate() {
      this.time = "";
    },
    getTestType(name) {
      return {
        testType: this.testTypes.find((testType) => testType.name === name),
        name: name,
      };
    },
    getSetTest(name) {
      return {
        testType: this.setTests.filter((setTest) =>
          setTest.name.includes(name)
        ),
        name: name,
      };
    },
    async reset(isClickFromButton = true) {
      if (isClickFromButton) {
        const alert = await this.$swal.fire({
          title: "ยืนยันรีเซ็ต",
          text: "คุณต้องการล้างค่าคำสั่งตรวจใช่หรือไม่",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "รีเซ็ต",
          cancelButtonText: "ยกเลิก",
        });

        if (!alert.value) {
          return;
        }
      }

      this.items = [];
      this.testSelected = [];
      this.select = [];
      this.time = "";
      this.emergency = "";
      this.otherSpecimen = "";
    },
    async submit() {
      if (this.data == null) {
        this.$store.state.isLoading = false;
        this.$router.push({ name: "history" });
      } else {
        if (this.isSending) {
          return;
        }
        this.isSending = true;
        let permission = await this.permission("animal_history", "can_order");
        if (!permission) {
          this.$swal.fire("Error", "ไม่มีสิทธิ์", "error");
          this.$store.state.isLoading = false;
          this.isSending = false;
          return;
        }

        if (this.data.id == "") {
          this.$swal.fire("เกิดข้อผิดพลาด", "ไม่มีข้อมูลสัตว์", "error");
          this.$store.state.isLoading = false;
          this.isSending = false;
          return;
        }

        let otherSpecimenSelect = this.selectedSpecimenTypes.find(
          (specimen) => specimen.name === "Other"
        );

        if (otherSpecimenSelect) {
          if (!this.otherSpecimen || this.otherSpecimen === "") {
            this.$swal.fire(
              "เกิดข้อผิดพลาด",
              "ยังไม่ได้กรอกชื่อ Specimen",
              "error"
            );
            this.$store.state.isLoading = false;
            this.isSending = false;
            return;
          }
        }

        if (this.select.length == 0 || this.items.length == 0) {
          this.$swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกสิ่งที่จะตรวจ", "error");
          this.$store.state.isLoading = false;
          this.isSending = false;
          return;
        }

        // if (this.emergency == "1") {
        //   if (this.time == "") {
        //     this.$swal.fire("เกิดข้อผิดพลาด", "ยังไม่ได้เลือกเวลา", "error");
        //     this.$store.state.isLoading = false;
        //     this.isSending = false;
        //     return;
        //   }
        // }

        let payload;
        try {
          payload = await this.saveForm();
        } catch (error) {
          this.$store.state.isLoading = false;
          this.isSending = false;
          return;
        }
        let html = `
        <div style="text-align: left;">
          <div style="text-align: center; color: red; font-weight: bold;">
            โปรดตรวจสอบข้อมูลให้ถูกต้อง
          </div>
          <table style="width: 100%;">
          <tr>
          <td>โรงพยาบาล</td><td>: ${
            payload.hospital_name
          }</td><td>วันที่สั่งตรวจ</td><td>${payload.order_date}</td>
          </tr>
          <tr>
          <td>ชื่อสัตว์</td><td>: ${payload.animal_name}</td><td>${
          payload.emergency_level
            ? '<span style="color: red; font-weight: bold;">ด่วนพิเศษ</span>'
            : ""
        }</td><td>${payload.emergency_level ? payload.sending_time : ""}</td>
          </tr>
          <tr>
          <td>Species</td><td>: ${
            payload.specie_name === "อื่นๆ"
              ? payload.other_specie
              : payload.specie_name
          }</td><td>สั่งตรวจโดย</td><td>${this.$store.state.Auth.user.name}</td>
          </tr>
          </table>
        </div>
        <div>
          <table class="table">
          <tr><th>Specimen Type</th><th>Test</th></tr>
        `;
        for (const item of payload.test_orders) {
          html += `<tr><td style="text-align:left;">${
            item.speciment_type_name
          }</td><td style="text-align:left;">${
            item.set_test_name ? "[" + item.set_test_name + "] " : ""
          }${item.test_name}</td></tr>`;
        }

        html += `</table>`;

        // const alert = await this.$swal.fire({
        //   title: "ยืนยันคำสั่งตรวจ",
        //   width: 1000,
        //   html,
        //   icon: "warning",
        //   showCancelButton: true,
        //   confirmButtonColor: "#3085d6",
        //   cancelButtonColor: "#d33",
        //   onOpen: () => {
        //     this.$swal.showLoading();
        //     setTimeout(() => {
        //       this.$swal.hideLoading();
        //     }, 3000);
        //   },
        //   confirmButtonText: "ยืนยันสั่งตรวจ",
        //   cancelButtonText: "ยกเลิก",
        // });

        // if (!alert.value) {
        //   this.$store.state.isLoading = false;
        //   this.isSending = false;
        //   return;
        // }

        if (this.$store.state.isEditing) {
          const alert = await this.$swal.fire({
            title: "ข้อมูลสัตว์มีการเปลี่ยนแปลง",
            text: "คุณต้องการบันทึกก่อนสั่งตรวจหรือไม่",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "บันทึก",
            cancelButtonText: "ไม่บันทึก",
          });

          if (alert.value) {
            await await this.saveAnimalFunction(this.data);
            this.$store.state.isLoading = true;
          } else {
            this.$store.state.isEditing = false;
            // this.isSending = false
          }
        }

        // let permission = await this.permission("animal_history", "can_order");
        // if (permission) {
        this.confirm = true;
        // if (data.id != "") {

        // if (this.select.length != 0 && this.items.length != 0) {
        await this.sleep(Math.floor(Math.random() * (1000 - 0 + 1)) + 0);
        // if (this.emergency == "1") {
        // if (this.time != "") {

        await this.saveOrder(payload);
        // this.$store.state.isLoading = false
        this.$router.push({ name: "receive" });
        // } else {
        //   this.$swal.fire('เกิดข้อผิดพลาด', 'ยังไม่ได้เลือกเวลา', 'error')
        //   this.$store.state.isLoading = false
        //   this.isSending = false
        //   return
        // }
        // } else {
        //   let payload
        //   try {
        //     payload = await this.saveForm();
        //   } catch(error) {
        //     console.log('error', error)
        //     this.$store.state.isLoading = false
        //     this.isSending = false
        //     return;
        //   }
        //   await this.saveOrder(payload);
        //   this.$store.state.isLoading = false
        //   this.$router.push({ name: "receive" });
        // }

        // } else {
        // this.$swal.fire('เกิดข้อผิดพลาด', 'กรุณาเลือกสิ่งที่จะตรวจ', 'error')
        // this.$store.state.isLoading = false
        // this.isSending = false
        // return
        // }
        // } else {
        // this.$swal.fire('เกิดข้อผิดพลาด', 'ไม่มีข้อมูลสัตว์', 'error')
        // this.$store.state.isLoading = false
        // this.isSending = false
        // return
        // }
        // }
        this.$store.state.isLoading = false;
        this.isSending = false;
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    saveForm() {
      let test_order = [];
      let test_in_array = [];
      let set_test_in_array = [];
      const labOrder = [];
      for (let index = 0; index < this.items.length; index++) {
        // test
        let linkSpecimenType = false;
        let hasSpecimenType = false;
        if (this.items[index].set_test_detail == undefined) {
          for (const element of this.selectedSpecimenTypes) {
            if (element.test.map((t) => t.id).includes(this.items[index].id)) {
              if (!test_in_array.includes(this.items[index].id)) {
                let test = {
                  specimen_type_id: element.id,
                  speciment_type_name: element.name,
                  test_id: this.items[index].id,
                  test_name: this.items[index].name,
                };
                test_order.push(test);
                labOrder.push({
                  id: this.items[index].id,
                  type: "test",
                });
                test_in_array.push(this.items[index].id);
                linkSpecimenType = true;
              }

              hasSpecimenType = true;
            }
          }

          if (!linkSpecimenType || !hasSpecimenType) {
            this.$swal.fire(
              "Error",
              `${this.items[index].name} ไม่ตรงกับ Specimen Type กรุณาเลือกใหม่`,
              "error"
            );
            this.$store.state.isLoading = false;
            throw "Test ไม่ตรงกับ Specimen Type กรุณาเลือกใหม่";
          }
          // set test
        } else {
          for (const setEl of this.items[index].set_test_detail) {
            let hasSpecimenType = false;
            // if (this.selectedSpecimenTypes.map(specimen => specimen.id).includes(setEl.test_id)) {
            for (const element of this.selectedSpecimenTypes) {
              if (element.test.map((t) => t.id).includes(setEl.test_id)) {
                if (!test_in_array.includes(setEl.test_id)) {
                  let test = {
                    specimen_type_id: element.id,
                    speciment_type_name: element.name,
                    test_id: setEl.test_id,
                    test_name: setEl.test_name,
                    set_test_name: this.items[index].name,
                  };
                  test_order.push(test);
                  test_in_array.push(setEl.test_id);
                  linkSpecimenType = true;
                }

                if (!set_test_in_array.includes(this.items[index].id)) {
                  labOrder.push({
                    id: this.items[index].id,
                    type: "setTest",
                  });
                  set_test_in_array.push(this.items[index].id);
                }
                hasSpecimenType = true;
              }
            }

            if (!linkSpecimenType || !hasSpecimenType) {
              this.$swal.fire(
                "Error",
                `${this.items[index].name} ไม่ตรงกับ Specimen Type กรุณาเลือกใหม่`,
                "error"
              );
              this.$store.state.isLoading = false;
              throw "Test ไม่ตรงกับ Specimen Type กรุณาเลือกใหม่";
            }

            // }
          }
        }
      }

      const payload = {
        animal_id: this.data.id,
        hospital_name: this.data.hospital_name,
        animal_name: this.data.name,
        is_out_lab: this.isOutLab,
        other_specie: this.data.other_specie,
        specie_name: this.data.species.species_name,
        hospital_id: this.objHospitals[this.data.hospital_name]
          ? this.objHospitals[this.data.hospital_name]
          : "",
        emergency_level: this.emergency ? 1 : 0,
        sending_time: this.emergency ? moment(this.time).format("HH:mm") : "",
        status_id: 1,
        test_orders: test_order,
        order_date: moment(this.dateNow).format("YYYY-MM-DD"),
        results: [],
        labOrder,
        otherSpecimen: this.otherSpecimen,
      };

      return payload;
    },
    async setHospitals() {
      const array = [];
      const obj = [];
      await this.hospitals.forEach((element) => {
        array.push(element.name);
        obj[element.name] = element.id;
      });
      this.lstHospitals = array;
      this.objHospitals = obj;
    },
    setGenders() {
      const array = [];
      const obj = [];
      this.genders.forEach((element) => {
        array.push(element.gender_name);
        obj[element.gender_name] = element.id;
      });
      this.lstGenders = array;
      this.objGenders = obj;
    },
    checkBilirubin(test, isAdd = true) {
      if (test) {
        if (test.abbreviation === "TBIL") {
          if (
            !this.items.find((test) => {
              if (!test) {
                return false;
              }
              return test.abbreviation === "DBIL";
            })
          ) {
            if (isAdd) {
              const dbtlObject = this.testTypes.find((testType) => {
                if (!testType.test) {
                  return false;
                }
                return testType.test.find(
                  (test) => test.abbreviation === "DBIL"
                );
              });

              this.items.push(
                dbtlObject.test.find((test) => test.abbreviation === "DBIL")
              );
            } else {
              this.items = this.items.filter(
                (test) => test.abbreviation !== "DBIL"
              );
            }
          } else {
            if (!isAdd) {
              this.items = this.items.filter(
                (test) => test.abbreviation !== "DBIL"
              );
            }
          }
        } else if (test.abbreviation === "DBIL") {
          if (
            !this.items.find((test) => {
              if (!test) {
                return false;
              }
              return test.abbreviation === "TBIL";
            })
          ) {
            if (isAdd) {
              const tbilObject = this.testTypes.find((testType) => {
                if (!testType.test) {
                  return false;
                }
                return testType.test.find(
                  (test) => test.abbreviation === "TBIL"
                );
              });
              this.items.push(
                tbilObject.test.find((test) => test.abbreviation === "TBIL")
              );
            } else {
              this.items = this.items.filter(
                (test) => test.abbreviation !== "TBIL"
              );
            }
          } else {
            if (!isAdd) {
              this.items = this.items.filter(
                (test) => test.abbreviation !== "TBIL"
              );
            }
          }
        }
      }
    },
  },
  watch: {
    testSelected(newVal, oldVal) {
      let newTestAdd = newVal.find((value) => !oldVal.includes(value));
      let newTestDel = oldVal.find((value) => !newVal.includes(value));
      if (newTestAdd) {
        this.checkBilirubin(newTestAdd);
      } else if (newTestDel) {
        this.checkBilirubin(newTestDel, false);
      }
    },
    async select(value) {
      await this.selected(value);
    },
    items(newVal, oldVal) {
      this.items.forEach((element) => {
        if (element.set_test_detail != undefined) {
          element.set_test_detail.forEach((x) => {
            this.items.forEach((y) => {
              if (y.set_test_detail == undefined) {
                if (y.id == x.test_id) {
                  this.items.splice(this.items.indexOf(y), 1);
                  this.$swal.fire(
                    "เกิดข้อผิดพลาด",
                    "ไม่สามารถเลือกได้ เพราะได้ถูกเลือกใน Set Test ไปแล้ว",
                    "error"
                  );
                }
              }
            });
          });
        }
        let newTestAdd = newVal.find((value) => !oldVal.includes(value));
        let newTestDel = oldVal.find((value) => !newVal.includes(value));
        if (newTestAdd) {
          this.checkBilirubin(newTestAdd);
        } else if (newTestDel) {
          this.checkBilirubin(newTestDel, false);
        }
      });
    },
  },
};
</script>

<style scoped>
.left {
  text-align: left;
}

.box {
  background-color: #e5e5e5;
}

.mini-top-box {
  /* border: #2f3438 solid 1px; */
  margin: 10px;
  flex: 1px;
}

.text {
  padding-top: 10px;
  margin-left: 20px;
  font-weight: bold;
}
.check-box-top {
  width: 80%;
  /* border: #2f3438 solid 1px; */
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
}
.check-box {
  padding-left: 25px;
  display: inline-block;
}
.checkmark {
  top: 3px;
  left: 0px;
  height: 18px;
  width: 18px;
  margin-left: 0;
  margin-right: 0;
}
.icon {
  cursor: pointer;
}
.emergency-box {
  display: flex;
  align-items: center;
}
.emer-check-box {
  margin-bottom: 0px !important;
}
.emer-datetime {
  padding: 15px;
  padding-left: 10px;
}
.icon {
  cursor: pointer;
}
.datepicker-trigger {
  display: flex;
}
</style>
